import { render, staticRenderFns } from "./AssignAgentGroup.vue?vue&type=template&id=13436954&scoped=true"
import script from "./AssignAgentGroup.vue?vue&type=script&lang=js"
export * from "./AssignAgentGroup.vue?vue&type=script&lang=js"
import style0 from "./AssignAgentGroup.vue?vue&type=style&index=0&id=13436954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13436954",
  null
  
)

export default component.exports